import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Portfolio from '../Portfolio';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import {portfolioData } from '../../data/portfolioData';
import { updateMetaTags } from '../../helper/updateMetaTags';
import { Helmet } from 'react-helmet';

export default function PortfolioPage() {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  const prefix = isEn ? '/en' : '';

  pageTitle(t('portfolio.pageTitle'));
  const [active] = useState('all');
  const [itemShow, setItemShow] = useState(7);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
        <Helmet>
      <title>{t('portfolio.metaTitle')}</title>
      <link rel="icon" href="/stablerecords.ico" />
      <meta name="description" content={t('portfolio.metaDescription')} />
    </Helmet>
      <div>
        {updateMetaTags("Poslechněte si skladby na kterých jsme spolupracovali s různými umělci. Nabízíme špičkové nahrávání, mix a mastering. Kontaktujte nás pro rezervaci termínu!", "nahrávací studio Praha, profesionální nahrávání, mix a mastering, hudební produkce, audio služby")}
      </div>
      <PageHeading
        title={t('portfolio.pageTitle')}
        bgSrc="images/portfolio_hero_bg.jpeg"
        pageLinkText={t('portfolio.pageTitle')}
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <Div className="cs-portfolio_1_heading">
          <SectionHeading title={t('portfolio.sectionTitle')} subtitle={t('portfolio.sectionSubtitle')} />
        </Div>
        <Spacing lg="90" md="45" />
        <Div className="row">
          {portfolioData.slice(0, itemShow).map((item, index) => (
            <Div
              className={`${
                index === 3 || index === 6 ? 'col-lg-8' : 'col-lg-4'
              } ${
                active === 'all'
                  ? ''
                  : !(active === item.category)
                  ? 'd-none'
                  : ''
              }`}
              key={index}
            >
              <Portfolio
                title={item.title}
                subtitle={item.subtitle}
                href={'/portfolio/' + item.id}
                src={item.src}
                variant="cs-style1 cs-type1"
              />
              <Spacing lg="25" md="25" />
            </Div>
          ))}
        </Div>

        <Div className="text-center">
          {portfolioData.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span
                className="cs-text_btn"
                onClick={() => setItemShow(itemShow + 3)}
              >
                <span>{t('portfolio.loadMore')}</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>
      <Spacing lg="80" md="50" />
      <Div className="container">
        <SectionHeading
          title={t('portfolio.spotifyTitle')}
          subtitle={t('portfolio.spotifySubtitle')}
          center
        />
        <Spacing lg="50" md="30" />
        <Div className="row justify-content-center">
          <Div className="col-lg-10">
            <iframe
              style={{ borderRadius: '12px' }}
              src="https://open.spotify.com/embed/playlist/5rhEnx2uuNk8G7tmrqCmxH?utm_source=generator"
              width="100%"
              height="380"
              frameBorder="0"
              allowFullScreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              title="Stable Records – Spotify playlist"
            />
          </Div>
        </Div>
      </Div>
      <Spacing lg="145" md="80" />
      <Cta
        title="studio@stablerecords.cz"
        bgSrc="/images/cta_bg_2.jpeg"
        variant="rounded-0"
      />
    </>
  );
}